export default __webpack_public_path__ + "static/media/battery-0.cdcf8361.svg";